<template>
  <div class="modal" tabindex="-1" id="wheel__modal">
    <transition name="fadeOut" v-if="stepNumber == 1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body position-relative pt-0">
            <div data-bs-theme="dark">
              <button type="button" class="btn-close position-absolute end-0 m-0 pt-4 btn-close-black"
                data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="container">
              <div class="row justify-content-center">
                <div class="col-12 text-center mb-3 mb-md-5">
                  <img src="../assets/images/campaigns/2026/mex-independence/lbl-01.png" alt="" class="w-50">
                </div>
                <div class="col-12 text-center mb-3 mb-md-4">
                  <span class="lbl fs-4 lh-1">SPIN THE WHEEL & UNLOCK <br>
                    YOUR FIESTA BONUS</span>
                </div>
                <div id="wheel__interface" class="col-12 mb-3">
                  <div class="roulette-container position-relative">
                    <img src="@/assets/images/campaigns/2026/mex-independence/wheel.png" alt="ruleta" class="wheel"
                      :style="{ transform: `rotate(${rotation}deg)` }" />
                    <div class="position-absolute start-50 translate-middle spinner top-0">
                      <img src="../assets/images/campaigns/2026/mex-independence/pointer.png" alt="" class=" w-50">
                    </div>
                  </div>
                </div>
                <div class="col-12 d-flex justify-content-center mb-4 mb-md-5">
                  <div class=" btn-spin rounded-pill text-center" @click="spin">SPIN & WIN</div>
                </div>
                <div class="col-12 col-lg-10 text-center">
                  <p class="terms">
                    Does not apply with other promotions.<br />
                    Valid with the purchase of a Vacation Package to&nbsp;Mexico.<br>
                    'Only with the purchase of a $599 package.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="fadeOut" mode="out-in">
      <div class="modal-dialog" v-if="stepNumber == 2" key="step2">
        <div class="modal-content modal-prize">
          <div class="modal-body position-relative p-0">
            <div data-bs-theme="dark">
              <button type="button" class="btn-close position-absolute end-0 m-0 pt-4 btn-close-white "
                data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="container">
              <div class="row justify-content-center mt-lg-4">
                <div class="col-12 text-center position-relative d-grid mt-4 lh-1">
                  <span class="pb-1 fs-1 luckiest-guy-regular">CONGRATS!</span>
                  <span class="fs-4 baloo-2-bold">YOU UNLOCKED A <br> MEXICAN STYLE BONUS </span>
                </div>
                <div class="col-12 text-center">
                  <img v-if="selectedPrize.imgUrl" :src="selectedPrize.imgUrl" alt="" class="w-50 mt-4">
                </div>
                <div class="col-12 d-grid text-center lh-1 text-white py-3 mt-3 mb-3">
                  <span class="fw-light" style="letter-spacing: 0.5px;">
                    Complete your registration and one <br>
                    of our travel experts Will contact you <br>
                    to help you redeem your reward.
                  </span>
                </div>
                <div class="col-12">
                  <lotteryForm :prizeCode="selectedPrize.code" :prizeName="selectedPrize.name" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { useWebsiteStore } from '@/store/website';
import lotteryForm from "@/components/TheLotteryForm.vue"
import Confetti from 'canvas-confetti'

export default {
  data() {
    return {
      prizes: [
        {
          name: "FREE VEGAS TRIP",
          code: '#FREEVEGAS',
          imgUrl: require("../assets/images/campaigns/2026/mex-independence/prizes/prize-01.png")
        },
        {
          name: "$75 USD DISCOUNT",
          code: '#75USDISCOUNT',
          imgUrl: require("../assets/images/campaigns/2026/mex-independence/prizes/prize-02.png")
        },
        {
          name: "$100 USD DISCOUNT",
          code: '#100USDISCOUNT',
          imgUrl: require("../assets/images/campaigns/2026/mex-independence/prizes/prize-03.png")
        },
        {
          name: "7 Nights",
          code: '#7Nights',
          imgUrl: require("../assets/images/campaigns/2026/mex-independence/prizes/prize-04.png")
        },
        {
          name: "$50 USD DISCOUNT",
          code: '#50USDISCOUNT',
          imgUrl: require("../assets/images/campaigns/2026/mex-independence/prizes/prize-05.png")
        },
      ],
      rotation: 0,
      initialOffset: 0,
      isSpinning: false,
      isFlipping: false,
      selectedPrize: {},
      stepNumber: 1,
      now: new Date(),
      campaign: [
        {
          campaign: 'mex-independence',
          fromDate: new Date(2026, 8, 9, 0, 0, 0),     // October 1, 2026
          toDate: new Date(2026, 8, 17, 23, 59, 59),     // October 6, 2026
          image: 'banners/2026-fall.png'
        }
      ]
    };
  },
  components:
  {
    lotteryForm
  },
  mounted() {
     const isTestCampaign = this.$route.query.campaign
     const activeCampaign = this.campaign[0];
     const isWithinDateRange = this.now >= activeCampaign.fromDate && this.now <= activeCampaign.toDate;
     if (isTestCampaign === activeCampaign.campaign || isWithinDateRange) {
        this.showModal()
        const anglePerPrize = 360 / this.prizes.length;
        this.initialOffset = 1;
        this.rotation = 0;
     }
  },
  computed: {
    websiteStore() {
      return useWebsiteStore();
    }
  },
  methods: {
    showModal() {
      let bannerModal = document.querySelector('#wheel__modal', { backdrop: false });
      console.log(bannerModal)
      //eslint-disable-next-line
      const bannerModalInstance = new bootstrap.Modal(bannerModal);
      bannerModalInstance.show();
    },
    spin() {
      if (this.isSpinning) return;

      this.isSpinning = true;
      this.selectedPrize = null;

      const total = this.prizes.length;
      const anglePerPrize = 360 / total;
      const extraSpins = 5;
      const randomAngle = Math.floor(Math.random() * 360);

      const finalRotation = 360 * extraSpins + randomAngle;

      this.rotation += finalRotation;

      setTimeout(() => {
        this.isSpinning = false;
        const normalizedAngle = this.rotation % 360;
        const anglePerPrize = 360 / this.prizes.length;
        const adjustedAngle = (360 - normalizedAngle) % 360;
        const prizeIndex = Math.floor(adjustedAngle / anglePerPrize);
        this.selectedPrize = this.prizes[prizeIndex];
        setTimeout(() => {
          this.stepNumber = 2
          this.getConfetti()
        }, 4000);
      }, 500);
    },
    getConfetti() {
      Confetti({
        particleCount: 100,
        spread: 70,
        origin: { y: 0.6 },
        zIndex: 2000,
        shapes: ['circle'],
        colors: ['#d5a432']
      })
    },
  }
};
</script>

<style scoped>
.modal-content {
  background-image: url('../assets/images/campaigns/2026/mex-independence/bg.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  min-height: 100%;
  width: 100%;

}

.btn-close {
  background-color: transparent !important;
}

.lbl {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-style: normal;
  color: #fff;
  letter-spacing: 1px;
}

#wheel__interface {
  text-align: center;
  font-family: Arial, sans-serif;
}

.roulette-container {
  position: relative;
  width: 300px;
  height: 300px;
  margin: 0 auto;
}

.wheel {
  width: 100%;
  height: 100%;
  transition: transform 4s cubic-bezier(0.33, 1, 0.68, 1);
  transform-origin: center;
  border-radius: 50%;
}

button {
  margin-top: 20px;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
}

.spinner {
  margin-top: 2rem;
}

.btn-spin {
  cursor: pointer;
  color: #fff;
  background: #E53A88;
  background: linear-gradient(180deg, rgba(229, 58, 136, 1) 0%, rgba(207, 6, 110, 1) 99%);
  border-color: none !important;
  font-size: 24px;
  font-weight: bold;
  box-shadow: 1px 7px 0px -1px #fcfaf4;
  -webkit-box-shadow: 1px 7px 0px -1px #990225;
  -moz-box-shadow: 1px 7px 0px -1px #947405;
  padding: 0.5rem 1.5rem;
}

.terms {
  font-size: 11px;
  color: white !important;
  font-weight: 400;
}

.baloo-2-bold {
  font-family: "Baloo 2", sans-serif;
  font-optical-sizing: auto;
  font-weight: 700;
  font-style: normal;
}

@media(max-width:420px) {
  .terms {
    font-size: 10px;
    word-break: keep-all;
  }
}

.w-50 {
  width: 3%;
}

/*--------PRIZE MODAL--------*/

.modal-content.modal-prize {
  background-image: url('../assets/images/campaigns/2026/mex-independence/bg.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center 10%;
  min-height: 100%;
  width: 100%;
  color: #fff;
}

.luckiest-guy-regular {
  font-family: "Luckiest Guy", cursive;
  font-weight: 400;
  font-style: normal;
}

@media(max-width:375px) {
  .terms {
    font-size: 9px;
  }
}

@media(max-width:400px) {
  .terms {
    font-size: 11px;
    letter-spacing: -0.5px;
  }
}
</style>